<template>

    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="add">新增</el-button>

            <div style="margin-right: 20px">
                <el-input


                        size="mini"
                        style="width: 200px  "

                        placeholder="请输入搜索内容"
                        v-model="Searchdata"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Searchrevise" size="mini"></el-button>
            </div>
        </div>
        <el-table
                id="eltable"

                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    width="50"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="模板名称"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="jsonData"
                    label="录入模板内容"

                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column

                    label="状态"

                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <div >
                        <span v-if="scope.row.state==1">启用</span>
                        <span v-if="scope.row.state==0">未启用</span>
                        <span v-if="scope.row.state==-1">{{$t('button_nullify')}}</span>
                    </div>

                </template>
            </el-table-column>
            <el-table-column
                    prop="describe"
                    label="描述"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="创建时间"
width="130"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="lruName"
                    label="录入人"
width="70"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    width="100"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button style="color:red;"  type="text" size="mini" @click="del(scope.row)">{{$t('button_nullify')}}</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"

                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
                <el-dialog
                        :close-on-click-modal="false"
                        style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                        top="280px"
                       width="600px"
                        height="300"
                        :title="title"
                        :visible.sync="bianjipingtai"
                        v-if="bianjipingtai"
                >
                    <revise-template  @getTemplatesList="getTemplatesList" :editData="editData" @close="close"></revise-template>
                </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import reviseTemplate from "./component/reviseTemplate";

    export default{
        name:'EnterTemplate',
        components:{
            reviseTemplate,

        },

        data(){
            return{
                editData:{},
                bianjipingtai:false,//编辑弹框
                Searchdata:'',//搜索内容
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                baseerp:'',
                tableData: [],
                tableHeight:0,//列表高度
                consumername:[],//消费名字数据
                title:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })

            //公共样式
            this.baseerp=baseerp
            this.getTemplatesList()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;

                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },


            //关闭弹框
            close(){
                this.bianjipingtai=false
            },
            //页面搜索
            Searchrevise(){
                this.getTemplatesList()
                this.currentPage=1
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getTemplatesList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getTemplatesList()
            },
            //新增
            add(){

                this.title='新增'
                this.editData={
                    id:0,
                    name:'',
                    jsonData:'',
                    describe:'',
                    lruid:parseFloat(sessionStorage.getItem("userid")) ,
                    lruName:sessionStorage.getItem('lruname'),
                    state:1

                }
                this.bianjipingtai=true
            },
            //编辑
            edit(val){
                this.title='编辑'
                // console.log(val)
                this.editData.id=val.id
                this.editData=Object.assign({},val);

                this.bianjipingtai=true
                // this.getServiceConfigDetail()

                // console.log(this.editData)
            },
            //确认作废
            submitdel(){
                this.voidTemplate()

                // console.log(this.editData)
                this.delDialogVisible=false
            },
//作废
            del(val){
                this.title='删除'
                this.editData=val
                this.templateUsed()
                this.delDialogVisible=true

                // console.log(this.editData)
                // console.log(this.editData.id)
            },
            //业务配置详情查询
            // async getServiceConfigDetail() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         id:this.editData.id
            //     }
            //     let res = await API.getServiceConfigDetail(params);
            //     if (res.code == 1) {
            //         this.editData=res.detail
            //         this.bianjipingtai=true
            //         this.editData.xfname=this.consumername
            //         // this.editData.enble=val.state
            //         this.editData.ywlxOld=res.detail.ywlx
            //         this.editData=Object.assign({},res.detail);
            //         // console.log(res)
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
            //业务配置列表查询
            async getTemplatesList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                let res = await API.getTemplatesList(params);
                if (res.code == 1) {
                    this.tableData=res.templatesList
                    this.total=res.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //作废验证
            async templateUsed() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id
                }
                let res = await API.templateUsed(params);
                if (res.code == 1) {
                    this.deldetail='是否要删除'
                    // console.log(res)
                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    // console.log(res)
                    this.deldetail=res.message

                    // this.$message.error(res.message);
                }
            },
            //业务配置作废
            async voidTemplate() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    // ywlx:this.editData.ywlx,
                    id:this.editData.id
                }
                let res = await API.voidTemplate(params);
                if (res.code == 1) {

                    this.getTemplatesList()

                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.$message.error(res.message);
                }
            },


        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>